import React from 'react';
import { Col, Tooltip } from 'antd';
import { FormattedMessage } from 'react-intl';
import { ReactMic } from '@cleandersonlobo/react-mic';
import { v4 as uuidv4 } from 'uuid';
import { AudioOutlined, BorderOutlined, SoundOutlined } from '@ant-design/icons';

const AudioRecorder = ({ state, setState }) => {
	const toggleRecording = () => {
		if (state.voice_recording instanceof Audio) {
			state.voice_recording.pause();
		}
		setState({
			recording: !state.recording,
			recordButton: state.recording ? (
				<AudioOutlined />
			) : (
				<>
					<BorderOutlined /> <FormattedMessage id="recording_audio" />
				</>
			),
			recordingButtonFontSize: state.recording ? '1.5em' : '0.9em',
			recordingButtonAnimation: state.recording ? 'none' : 'blinking .5s linear infinite alternate',
			listeningButtonAnimation: 'none',
		});
	};

	const playVoiceRecording = () => {
		if (state.voice_recording instanceof Audio) {
			if (state.voice_recording.ended || state.voice_recording.currentTime === 0.0) {
				state.voice_recording.play();
				setState({ listeningButtonAnimation: 'blinking .5s linear infinite alternate' });
			} else {
				state.voice_recording.pause();
				state.voice_recording.currentTime = 0.0;
				setState({ listeningButtonAnimation: 'none' });
			}
		}
	};

	const onStop = (recordedBlob) => {
		setState({ recordedBlob });
		attachVoiceRecording(recordedBlob);

		const reader = new FileReader();
		reader.readAsDataURL(recordedBlob.blob);
		reader.onloadend = function () {
			const base64data = reader.result;
			const audio = new Audio(base64data);
			audio.onended = () => {
				setState({ listeningButtonAnimation: 'none' });
			};
			setState({ voice_recording: audio });
		};
	};

	const attachVoiceRecording = (recordedBlob) => {
		if (recordedBlob) {
			const file = new File([recordedBlob.blob], uuidv4() + '.mp3', {
				type: recordedBlob.blob.type,
			});
			file.uid = uuidv4();
			file.status = 'done';
			file.response = 'ok';
			setState({ files: [file] });
		}
	};

	return (
		<>
			<div style={{ display: 'none' }}>
				<ReactMic record={state.recording} mimeType="audio/mp3" onStop={onStop} />
			</div>

			<Col span={2} style={{ padding: '5px' }}>
				<Tooltip title={<FormattedMessage id="record_audio_tooltip" />}>
					<button
						style={{
							outline: 'none',
							color: '#3bc8f5',
							width: '100%',
							height: '90px',
							fontSize: '1.5em',
							backgroundColor: 'transparent',
							border: '1px solid rgba(0, 0, 0, 0.15)',
							animation: state.recordingButtonAnimation,
						}}
						onClick={toggleRecording}
						type="button"
					>
						{state.recordButton}
					</button>
				</Tooltip>
			</Col>

			<Col span={1} style={{ padding: '5px 5px 5px 0' }}>
				<Tooltip placement="bottom" title={<FormattedMessage id="play_audio_tooltip" />}>
					<button
						style={{
							outline: 'none',
							color: '#3bc8f5',
							width: '100%',
							height: '90px',
							fontSize: '1.5em',
							backgroundColor: 'transparent',
							border: '1px solid rgba(0, 0, 0, 0.15)',
							animation: state.listeningButtonAnimation,
						}}
						onClick={playVoiceRecording}
						type="button"
					>
						<SoundOutlined />
					</button>
				</Tooltip>
			</Col>
		</>
	);
};

export default AudioRecorder;
